import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../BottomNav';
import UserCard from './UserCard';
import { searchPublicProfiles } from '../../lib/database';

function CommunityPage() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const seq = useRef(0);

  const runSearch = useCallback(async (q) => {
    const mySeq = ++seq.current;
    setLoading(true);
    const data = await searchPublicProfiles(q);
    if (mySeq !== seq.current) return; // risposta obsoleta
    setResults(data);
    setLoading(false);
  }, []);

  // Ricerca iniziale (profili pubblici) + debounce su digitazione
  useEffect(() => {
    const t = setTimeout(() => runSearch(query), query ? 350 : 0);
    return () => clearTimeout(t);
  }, [query, runSearch]);

  return (
    <div className="min-h-screen bg-gray-50 page-with-bottom-nav">
      <header className="bg-white border-b border-gray-100 px-5 pt-12 pb-4">
        <h1 className="text-xl font-bold text-gray-900">Community</h1>
        <p className="text-xs text-gray-400 mt-0.5">Scopri altri atleti su Uptra</p>
        <div className="mt-3 flex items-center gap-2 bg-gray-100 rounded-xl px-3 py-2.5">
          <span className="text-gray-400">🔍</span>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Cerca per nome o @username"
            autoCapitalize="none"
            autoCorrect="off"
            className="flex-1 bg-transparent text-sm outline-none"
          />
          {query && (
            <button type="button" onClick={() => setQuery('')} className="text-gray-400 text-sm">
              ✕
            </button>
          )}
        </div>
      </header>

      <main className="px-4 py-5 max-w-lg mx-auto">
        {loading ? (
          <p className="text-center text-sm text-gray-400 py-10">Caricamento…</p>
        ) : results.length === 0 ? (
          <div className="text-center py-14">
            <div className="text-4xl mb-3">🫥</div>
            <p className="text-sm text-gray-500 font-medium">Nessun profilo pubblico trovato</p>
            <p className="text-xs text-gray-400 mt-1">
              {query ? 'Prova con un altro nome o username.' : 'Torna più tardi: la community sta crescendo.'}
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {results.map((u) => (
              <UserCard
                key={u.id}
                user={u}
                onClick={() => u.username && navigate(`/athlete/community/${u.username}`)}
              />
            ))}
          </div>
        )}
      </main>

      <BottomNav />
    </div>
  );
}

export default CommunityPage;
